<div class="h-screen flex flex-col overflow-hidden bg-pageBg">
    <app-header class="shrink-0"></app-header>
    <div class="flex-1 flex flex-col min-h-0 overflow-hidden pt-4 pb-[44px] text-gray-800 antialiased">
        <div class="w-full mx-auto px-4 xl:px-8 flex flex-col flex-1 h-full overflow-hidden">

            <!-- Header Section -->
            <div class="relative bg-white border border-gray-200 shadow-sm rounded-2xl shrink-0 mb-4 mt-2"
                style="background-color: rgb(255, 253, 253);">
                <div
                    class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brandPurple via-brandPurpleDark to-brandAccent">
                </div>

                <div class="px-8 py-6 flex flex-col lg:flex-row lg:items-center justify-between gap-6"
                    style="background-color: aliceblue;">
                    <div>
                        <div class="flex items-center justify-between flex-wrap gap-4">
                            <div class="flex items-center gap-3">
                                <h2 class="text-2xl font-bold m-0">User Management</h2>
                                <span
                                    class="px-2 py-0.5 bg-brandPurple/10 text-brandPurple text-xs font-bold rounded-full whitespace-nowrap">
                                    {{ users.length }} Total
                                </span>
                            </div>

                        </div>
                        <p class="text-gray-500 text-sm mt-1">Configure user accounts, roles, and system access.</p>
                    </div>

                    <div class="flex flex-wrap items-center gap-4">
                        <!-- Integrated Search & Filters -->
                        <div
                            class="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-1.5 focus-within:ring-2 focus-within:ring-brandAccent/20 focus-within:border-brandAccent transition-all shadow-sm">
                            <svg class="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>
                            <input type="text"
                                class="bg-transparent border-none focus:ring-0 outline-none sm w-48 lg:w-64"
                                placeholder="Search name, username, or email..." [(ngModel)]="search"
                                (ngModelChange)="currentPage = 1; applyFilters()">
                        </div>

                        <div class="flex items-center gap-2">

                            <!-- STATUS DROPDOWN -->
                            <div class="relative">

                                <!-- BUTTON -->
                                <button type="button" (click)="showStatusDropdown = !showStatusDropdown"
                                    class="flex items-center justify-between min-w-[170px] text-sm py-2 pl-3 pr-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-brandAccent/20 transition-all">

                                    <span>
                                        {{
                                        statusFilter === 'active' ? 'Active Only' :
                                        statusFilter === 'inactive' ? 'Inactive Only' :
                                        'All Status'
                                        }}
                                    </span>

                                    <svg class="w-4 h-4 ml-3 text-gray-500" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">

                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7">
                                        </path>

                                    </svg>

                                </button>

                                <!-- OPTIONS -->
                                <div *ngIf="showStatusDropdown"
                                    class="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden">

                                    <div class="px-4 py-3 text-sm hover:bg-brandAccent/10 cursor-pointer"
                                        (click)="statusFilter='all'; showStatusDropdown=false; currentPage=1; applyFilters()">

                                        All Status

                                    </div>

                                    <div class="px-4 py-3 text-sm hover:bg-brandAccent/10 cursor-pointer"
                                        (click)="statusFilter='active'; showStatusDropdown=false; currentPage=1; applyFilters()">

                                        Active Only

                                    </div>

                                    <div class="px-4 py-3 text-sm hover:bg-brandAccent/10 cursor-pointer"
                                        (click)="statusFilter='inactive'; showStatusDropdown=false; currentPage=1; applyFilters()">

                                        Inactive Only

                                    </div>

                                </div>

                            </div>


                            <!-- LOCATION DROPDOWN -->
                            <div class="relative" *ngIf="uniqueLocations().length">

                                <!-- BUTTON -->
                                <button type="button" (click)="showLocationDropdown = !showLocationDropdown"
                                    class="flex items-center justify-between min-w-[220px] w-full text-sm py-2 pl-3 pr-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-brandAccent/20 transition-all">

                                    <span class="truncate">
                                        {{ locationFilter === 'all' ? 'All Locations' : locationFilter }}
                                    </span>

                                    <svg class="w-4 h-4 ml-3 text-gray-500" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">

                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7">
                                        </path>

                                    </svg>

                                </button>

                                <!-- OPTIONS -->
                                <div *ngIf="showLocationDropdown"
                                    class="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden">

                                    <!-- SEARCH -->
                                    <div class="p-2 border-b border-gray-100">

                                        <input type="text" [(ngModel)]="locationSearch" placeholder="Search location..."
                                            class="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brandAccent/20">

                                    </div>

                                    <!-- DROPDOWN LIST -->
                                    <div class="max-h-[240px] overflow-y-auto">

                                        <div class="px-4 py-3 text-sm hover:bg-brandAccent/10 cursor-pointer"
                                            (click)="locationFilter='all'; showLocationDropdown=false; currentPage=1; applyFilters();">

                                            All Locations

                                        </div>

                                        <div *ngFor="let loc of uniqueLocations()"
                                            class="px-4 py-3 h-12 text-sm hover:bg-brandAccent/10 cursor-pointer truncate flex items-center"
                                            [class.hidden]="locationSearch && !loc.toLowerCase().includes(locationSearch.toLowerCase())"
                                            (click)="locationFilter=loc; showLocationDropdown=false; currentPage=1; applyFilters()">

                                            {{ loc }}

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                        <label
                            class="flex items-center gap-2 text-xs font-bold text-gray-600 cursor-pointer hover:bg-gray-50 px-3 py-2 rounded-xl transition-colors">
                            <input type="checkbox"
                                class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent"
                                [(ngModel)]="showBlockedOnly" (change)="currentPage = 1; applyFilters()">
                            BLOCKED
                        </label>

                        <div class="h-8 w-px bg-gray-200 mx-1 hidden lg:block"></div>

                        <div class="flex items-center gap-2">
                            <button
                                class="p-2.5 text-gray-500 hover:text-brandPurple hover:bg-brandPurple/10 rounded-xl transition-all"
                                (click)="loadUsers(true)" [disabled]="isRefreshTable" title="Refresh Table">
                                <svg class="w-5 h-5" [ngClass]="{'animate-spin': isRefreshTable}" fill="none"
                                    stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                                    </path>
                                </svg>
                            </button>
                            <button
                                class="p-2.5 text-gray-500 hover:text-brandPurple hover:bg-brandPurple/10 rounded-xl transition-all"
                                (click)="showHideColumnSettings()" [disabled]="isRefreshTable" title="Column Settings">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2m0 0V7a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2h-2a2 2 0 01-2-2V7">
                                    </path>
                                </svg>
                            </button>
                        </div>

                        <button
                            class="bg-brandAccent hover:bg-brandPurple text-white px-6 py-2.5 rounded-xl text-sm font-bold shadow-lg shadow-brandAccent/20 transition-all hover:shadow-brandAccent/40 hover:-translate-y-0.5 active:scale-95"
                            (click)="openCreateForm()">
                            Create User
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="message" [ngClass]="{'bg-red-50 border-red-500 text-red-700': messageColor === 'red',
                            'bg-green-50 border-green-500 text-green-700': messageColor ==='green',
                            'bg-yellow-50 border-yellow-500 text-yellow-700': messageColor ==='yellow'
                            }" class="mb-4 border-l-4  p-4 rounded-md shadow-sm">
                <p class=" text-sm font-bold">{{ message }}</p>
            </div>
            <div *ngIf="isRefreshTable"
                class="mb-4 bg-blue-50 border-l-4 border-blue-400 p-3 rounded-md shadow-sm flex justify-between items-center">
                <span class="text-blue-700 text-sm font-medium">{{ refreshTableText }}</span>
                <span class="text-blue-600 text-sm font-bold">{{ totalRecords }} records</span>
            </div>

            <div
                class="bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col flex-1 overflow-hidden min-h-0 mb-4">

                <!-- BODY SECTION: Scrollable -->
                <div class="overflow-auto flex-1 relative custom-scrollbar">
                    <table class="min-w-full text-xs lg:text-sm text-left table-fixed">
                        <colgroup>
                            <col *ngIf="columnVisibility['name']" class="w-[22%] lg:w-[20%]">
                            <col *ngIf="columnVisibility['username']" class="w-[16%] lg:w-[15%]">
                            <col *ngIf="columnVisibility['status']" class="w-[10%] lg:w-[10%]">
                            <col *ngIf="columnVisibility['email']" class="w-[22%] lg:w-[25%]">
                            <col *ngIf="columnVisibility['base_location']" class="w-[15%] lg:w-[15%]">
                            <col *ngIf="columnVisibility['is_service_accounts']" class="w-[5%] lg:w-[5%]">
                            <col *ngIf="columnVisibility['action']" class="w-[5%] lg:w-[5%]">
                            <col *ngIf="columnVisibility['view']" class="w-[5%] lg:w-[5%]">
                        </colgroup>
                        <thead class="text-gray-400">
                            <tr style="background-color: aliceblue">
                                <th *ngIf="columnVisibility['name']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('name')">
                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Name</span>
                                        <span class="sm:hidden text-[9px]">N</span>
                                        <svg *ngIf="sortType === 'name'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['username']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('username')">
                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Username</span>
                                        <span class="sm:hidden text-[9px]">U</span>
                                        <svg *ngIf="sortType === 'username'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['status']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('status')">
                                    <div class="flex items-center justify-center gap-1">
                                        <span class="hidden sm:inline">Status</span>
                                        <span class="sm:hidden text-[9px]">S</span>
                                        <svg *ngIf="sortType === 'status'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['email']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('recovery_email')">
                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Email</span>
                                        <span class="sm:hidden text-[9px]">E</span>
                                        <svg *ngIf="sortType === 'recovery_email'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['base_location']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('searchable_locations')">
                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Location</span>
                                        <span class="sm:hidden text-[9px]">L</span>
                                        <svg *ngIf="sortType === 'searchable_locations'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['is_service_accounts']"
                                    class="sticky top-0 z-10 px-2 lg:px-3 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('is_service_accounts')">
                                    <div class="flex items-center justify-center gap-1">
                                        <span class="hidden sm:inline">Service Account</span>
                                        <span class="sm:hidden text-[9px]">Service Account</span>
                                        <svg *ngIf="sortType === 'is_service_accounts'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['action']"
                                    class="sticky top-0 z-10 px-2 lg:px-3 py-3 lg:py-4 font-bold uppercase tracking-wider text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue">
                                    <span class="hidden sm:inline">Actions</span>
                                    <span class="sm:hidden text-[9px]">Act</span>
                                </th>
                                <th *ngIf="columnVisibility['view']"
                                    class="sticky top-0 z-10 px-2 lg:px-3 py-3 lg:py-4 font-bold uppercase tracking-wider text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue">
                                    <span class="hidden sm:inline">View</span>
                                    <span class="sm:hidden text-[9px]">V</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100/60">
                            <!-- Loading State -->
                            <tr *ngIf="!isLoaded || isRefreshTable">
                                <td colspan="8" class="text-center py-12 lg:py-20 bg-gray-50/50">
                                    <div class="flex flex-col items-center gap-4">
                                        <div
                                            class="w-7 lg:w-8 h-7 lg:h-8 border-4 border-brandAccent/20 border-t-brandAccent rounded-full animate-spin">
                                        </div>
                                        <span class="text-gray-400 font-medium text-xs lg:text-sm">Loading user
                                            data...</span>
                                    </div>
                                </td>
                            </tr>

                            <!-- Empty State -->
                            <tr *ngIf="isLoaded && users.length === 0" class="h-full">
                                <td colspan="8" class="h-full text-center py-12 lg:py-20 align-middle">
                                    <div
                                        class="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white">
                                        <div class="p-3 lg:p-4 bg-gray-50 rounded-full">
                                            <svg class="w-6 lg:w-8 h-6 lg:h-8 text-gray-300" fill="none"
                                                stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
                                                </path>
                                            </svg>
                                        </div>
                                        <span class="text-gray-500 font-bold text-sm lg:text-base">No users match your
                                            filters.</span>
                                        <button
                                            class="text-brandAccent text-xs lg:text-sm font-bold hover:underline relative z-10"
                                            (click)="clearAllFilters()">
                                            Clear all filters
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <!-- Data Rows -->
                            <ng-container *ngIf="isLoaded && !isRefreshTable">
                                <tr *ngFor="let user of getPaginatedUsers()"
                                    class="group cursor-pointer transition-all duration-200" [ngClass]="{
            'bg-brandAccent/[0.03] border-l-4 border-l-brandAccent shadow-[inset_0_0_0_1px_rgba(var(--brandAccent-rgb),0.05)]':
                (selectedUser?.id || selectedUser?.user_id) === (user.id || user.user_id),

            'hover:bg-gray-50/80 border-l-4 border-l-transparent':
                (selectedUser?.id || selectedUser?.user_id) !== (user.id || user.user_id),

            'bg-gray-100 hover:bg-gray-200 opacity-80':
                user.is_blocked === 3,

            'hover:bg-green-100/50':
                user.status === 'Active' && user.is_blocked !== 3,

            'hover:bg-red-100/50':
                user.status === 'Inactive' && user.is_blocked !== 3
        }" (click)="viewUserDetails(user)">

                                    <td *ngIf="columnVisibility['name']" class="px-3 lg:px-6 py-3 lg:py-4">
                                        <div class="flex flex-col">

                                            <span
                                                class="font-bold transition-colors break-words whitespace-normal text-xs lg:text-sm"
                                                [ngClass]="{
        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
    }" [style.max-width]="'150px'" [style.min-width]="'80px'" [style.display]="'inline-block'"
                                                [style.word-break]="'break-word'" [style.white-space]="'normal'">
                                                {{ user.name }}
                                            </span>

                                            <span
                                                class="text-[9px] lg:text-[11px] text-black font-black uppercase tracking-tighter mt-0.5"
                                                *ngIf="user.is_blocked === 3">
                                                Account Blocked
                                            </span>
                                        </div>
                                    </td>

                                    <td *ngIf="columnVisibility['username']"
                                        class="px-3 lg:px-6 py-3 lg:py-4 font-medium text-xs lg:text-sm" [ngClass]="{
        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
    }">
                                        <span class="break-words whitespace-normal" [style.max-width]="'150px'"
                                            [style.display]="'inline-block'" [style.word-break]="'break-word'">
                                            {{ user.username }}
                                        </span>
                                    </td>
                                    <td *ngIf="columnVisibility['status']"
                                        class="px-3 lg:px-6 py-3 lg:py-4 text-center">

                                        <span [ngClass]="user.status === 'Active'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-red-100 text-red-600'"
                                            class="px-2 lg:px-2.5 py-0.5 lg:py-1 rounded-full text-[9px] lg:text-[11px] font-black uppercase tracking-wider">

                                            {{ user.status }}
                                        </span>
                                    </td>

                                    <td *ngIf="columnVisibility['email']"
                                        class="px-3 lg:px-6 py-3 lg:py-4 text-gray-600 truncate max-w-[150px] lg:max-w-[200px] text-xs lg:text-sm"
                                        [title]="user.recovery_email
            " [ngClass]="{
                        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
                        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
                    }">

                                        {{ user.recovery_email }}
                                    </td>

                                    <td *ngIf="columnVisibility['base_location']"
                                        class="px-3 lg:px-6 py-3 lg:py-4 text-gray-600 text-xs lg:text-sm" [ngClass]="{
                        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
                        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
                    }">

                                        <div class="flex flex-col">

                                            <span *ngIf="user.all_locations?.length > 1"
                                                class="text-brandPurple font-bold hover:underline text-xs lg:text-sm"
                                                (click)="viewUserBaseLocations(user, $event)" [ngClass]="{
                        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
                        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
                    }">

                                                View ({{ user.all_locations.length }})
                                            </span>

                                            <span *ngIf="user.all_locations?.length === 1"
                                                class="text-gray-600 cursor-pointer hover:text-brandPurple hover:underline text-xs lg:text-sm"
                                                (click)="viewUserBaseLocations(user, $event)" [ngClass]="{
                        'text-red-600 group-hover:text-red-700': user.is_blocked === 3,
                        'text-gray-600 group-hover:text-brandPurple': user.is_blocked !== 3
                    }">

                                                {{ user.all_locations[0] }}
                                            </span>

                                            <span *ngIf="!user.all_locations || user.all_locations.length === 0"
                                                class="text-gray-300 text-[10px]">
                                                —
                                            </span>

                                        </div>
                                    </td>

                                    <td *ngIf="columnVisibility['is_service_accounts']"
                                        class="px-2 lg:px-3 py-3 lg:py-4 text-center">

                                        <i *ngIf="user.is_service_accounts"
                                            class="fa-solid fa-check text-green-500 text-[10px]"></i>

                                        <i *ngIf="!user.is_service_accounts"
                                            class="fa-solid fa-xmark text-red-500 text-xs"></i>
                                    </td>

                                    <td *ngIf="columnVisibility['action']"
                                        class="px-2 lg:px-3 py-3 lg:py-4 text-center">

                                        <div class="flex items-center justify-center gap-2 lg:gap-4">

                                            <button *ngIf="user.status === 'Active'"
                                                class="text-yellow-600 hover:text-yellow-700 text-[8px] lg:text-xs font-bold uppercase tracking-tight whitespace-nowrap"
                                                (click)="$event.stopPropagation(); disableUser(user.id)">

                                                Disable
                                            </button>

                                            <button *ngIf="user.status === 'Inactive'"
                                                class="text-green-600 hover:text-green-700 text-[8px] lg:text-xs font-bold uppercase tracking-tight whitespace-nowrap"
                                                (click)="$event.stopPropagation(); enableUser(user.id)">

                                                Enable
                                            </button>

                                        </div>
                                    </td>

                                    <td *ngIf="columnVisibility['view']" class="px-2 lg:px-3 py-3 lg:py-4 text-center">

                                        <div class="flex items-center justify-center">

                                            <button
                                                class="w-8 lg:w-10 h-7 lg:h-8 flex items-center justify-center rounded-lg border border-purple-200 text-purple-600 bg-purple-50 hover:bg-purple-100 transition-all">

                                                <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                                    viewBox="0 0 24 24">

                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M9 5l7 7-7 7">
                                                    </path>

                                                </svg>
                                            </button>

                                        </div>
                                    </td>

                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <!-- PAGINATION SECTION: Fixed (Bottom) -->
                <div class="px-4 lg:px-8 py-3 lg:py-5 border-t border-gray-100 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 lg:gap-0 bg-gray-50/50 shrink-0"
                    *ngIf="isLoaded && users.length > 0">
                    <div class="text-[10px] lg:text-xs font-bold text-gray-400 uppercase tracking-widest">
                        Displaying <span class="text-gray-900">{{ (currentPage - 1) * pageSize + 1 }}-{{
                            getVisibleCount()
                            }}</span> of {{ users.length }}
                    </div>
                    <div class="flex flex-col sm:flex-row items-center gap-3 lg:gap-6">
                        <div class="flex items-center gap-1 p-1 bg-white border border-gray-200 rounded-xl">
                            <button *ngFor="let size of [10, 25, 50,100]"
                                class="px-1.5 lg:px-2 py-1 text-[9px] lg:text-[10px] font-black rounded-lg transition-all"
                                [ngClass]="pageSize === size ? 'bg-brandAccent text-white shadow-sm' : 'text-gray-400 hover:bg-gray-50'"
                                (click)="pageSize = size; currentPage = 1">{{size}}</button>
                        </div>
                        <div class="flex items-center gap-1 lg:gap-2">
                            <button
                                class="p-1.5 lg:p-2 border border-gray-200 rounded-xl bg-white text-gray-500 hover:text-brandPurple disabled:opacity-30 transition-all"
                                [disabled]="currentPage === 1" (click)="pageChange(currentPage - 1)">
                                <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path d="M15 19l-7-7 7-7" stroke-width="2" />
                                </svg>
                            </button>
                            <div class="flex items-center gap-1 px-2">
                                <span class="text-[9px] lg:text-xs font-bold text-gray-900">{{ currentPage }}</span>
                                <span class="text-[9px] lg:text-xs text-gray-300">/</span>
                                <span class="text-[9px] lg:text-xs font-bold text-gray-400">{{ getTotalPages() }}</span>
                            </div>
                            <button
                                class="p-1.5 lg:p-2 border border-gray-200 rounded-xl bg-white text-gray-500 hover:text-brandPurple disabled:opacity-30 transition-all"
                                [disabled]="currentPage * pageSize >= users.length"
                                (click)="pageChange(currentPage + 1)">
                                <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path d="M9 5l7 7-7 7" stroke-width="2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- User Details Sliding Drawer -->
            <div class="fixed inset-0 z-[110] overflow-hidden transition-all duration-500 ease-in-out pointer-events-none"
                [ngClass]="showUserDetails ? 'visible' : 'invisible'"
                *ngIf="userDetails && (userDetails.id || userDetails.user_id)">
                <!-- Backdrop -->
                <div class="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-500 ease-in-out pointer-events-auto"
                    [ngClass]="showUserDetails ? 'opacity-100' : 'opacity-0'" (click)="closeUserDetails()"></div>

                <!-- Drawer -->
                <div class="absolute inset-y-0 right-0 w-full max-w-2xl bg-white shadow-2xl transition-transform duration-500 ease-in-out pointer-events-auto flex flex-col"
                    [ngClass]="showUserDetails ? 'translate-x-0' : 'translate-x-full'">

                    <!-- Drawer Header -->
                    <div
                        class="px-8 py-6 border-b border-gray-100 flex items-center justify-between bg-white sticky top-0 z-10">
                        <div class="flex flex-col">
                            <h2 class="text-2xl font-black text-gray-900 tracking-tight">{{ userDetails.name }}</h2>
                            <div class="flex items-center gap-2 mt-1">
                                <span
                                    [ngClass]="userDetails.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'"
                                    class="px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-widest">
                                    {{ userDetails.status }}
                                </span>

                                <span class="text-gray-300 text-xs">&bull;</span>
                                <span class="text-gray-500 text-xs font-bold uppercase tracking-tighter">{{
                                    userDetails.username }}</span>
                            </div>
                            <div class="flex items-center gap-2 flex-wrap mt-4">
                                <!-- Role Error -->
                                <span *ngIf="currentUserRolesList.length === 0"
                                    class="flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-red-50 text-red-600 border border-red-100 text-[10px] font-black uppercase tracking-tight shadow-sm">
                                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    No Roles Assigned
                                </span>

                                <!-- Location Error -->
                                <span *ngIf="baseLocationsList.length === 0"
                                    class="flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-red-50 text-red-600 border border-red-100 text-[10px] font-black uppercase tracking-tight shadow-sm">
                                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    No Base Locations
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <button
                                class="w-10 h-10 flex items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                                (click)="closeUserDetails()">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Drawer Content -->
                    <div class="flex-1 overflow-y-auto p-8 bg-gray-50/30">
                        <!-- Tabs -->
                        <div class="flex items-center p-1 bg-gray-100 rounded-2xl mb-8">
                            <button *ngFor="let tab of ['summary', 'roles', 'sessions', 'locations']"
                                class="flex-1 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="activeTab === tab ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="tab === 'summary' ? activeTab = 'summary' : (tab === 'roles' ? loadRolesByUserId() : (tab === 'sessions' ? loadSessions() : loadBaseLocations()))">
                                {{ tab === 'locations' ? 'Base Location' : tab }}
                            </button>
                        </div>
                        <div *ngIf="userMessage" [ngClass]="{'bg-red-50 border-red-500 text-red-700': messageColor === 'red',
                                        'bg-green-50 border-green-500 text-green-700': messageColor ==='green',
                                        'bg-yellow-50 border-yellow-500 text-yellow-700': messageColor ==='yellow'
                                        }" class="mb-4 border-l-4  p-4 rounded-md shadow-sm">
                            <p class=" text-sm font-bold">{{ userMessage }}</p>
                        </div>

                        <!-- Actions Bar (Floating) -->
                        <div
                            class="mb-8 flex flex-wrap gap-4 items-center justify-between p-4 bg-white border border-brandAccent/20 rounded-2xl shadow-sm shadow-brandAccent/5">
                            <div class="flex flex-wrap gap-2">
                                <button
                                    class="px-4 py-2 bg-gray-50 hover:bg-brandAccent/10 text-gray-700 hover:text-brandAccent text-xs font-bold rounded-xl transition-all border border-brandAccent/10 active:scale-95"
                                    (click)="openUpdatePassword()">Change Password</button>
                                <button
                                    class="px-4 py-2 bg-gray-50 hover:bg-brandAccent/10 text-gray-700 hover:text-brandAccent text-xs font-bold rounded-xl transition-all border border-brandAccent/10 active:scale-95"
                                    (click)="openUpdateProfilePanel()">Update Profile</button>
                                <!-- Unblock Button -->
                                <button *ngIf="userDetails.is_blocked === 3"
                                    class="px-4 py-2 bg-green-50 hover:bg-green-100 text-green-700 text-xs font-bold rounded-xl transition-all border border-green-200 active:scale-95 flex items-center gap-2 shadow-sm"
                                    (click)="unblockUser(userDetails.user_id || userDetails.id)">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    Unblock User
                                </button>
                            </div>


                            <button
                                class="px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 text-xs font-bold rounded-xl transition-all border border-red-100 active:scale-95 flex items-center gap-2 shadow-sm"
                                (click)="openDeleteModal(userDetails.user_id || userDetails.id)">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                    </path>
                                </svg>
                                <span>{{ canHardDelete ? 'Hard Delete' : 'Soft Delete' }}</span>
                            </button>
                        </div>

                        <div *ngIf="showDeleteModal"
                            class="fixed inset-0 z-[200] flex items-center justify-center bg-black/50">
                            <div class="bg-white rounded-2xl p-6 w-80 text-center">
                                <div *ngIf="!deleteMessage">
                                    <div
                                        class="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
                                        <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold mb-2">Delete Account</h3>
                                    <p class="text-gray-600 mb-6">Are you sure?</p>
                                    <div class="flex gap-3 justify-center">
                                        <button (click)="closeDeleteModal()"
                                            class="px-4 py-2 border rounded-lg">Cancel</button>
                                        <button (click)="confirmDelete()"
                                            class="px-4 py-2 bg-red-600 text-white rounded-lg">Delete</button>
                                    </div>
                                </div>

                                <div *ngIf="deleteMessage" class="py-8">
                                    <p class="text-lg font-bold"
                                        [class.text-green-600]="deleteMessage.includes('successfully')"
                                        [class.text-red-600]="deleteMessage.includes('Failed')">
                                        {{ deleteMessage }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Summary Tab Content -->
                        <div *ngIf="activeTab === 'summary'" class="space-y-6">
                            <div class="grid grid-cols-2 gap-8">
                                <div class="space-y-4">
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">
                                            Business Email
                                        </label>
                                        <!-- Added 'break-words' to handle long strings -->
                                        <p class="text-sm font-bold text-gray-900 px-1 break-words">
                                            {{ userDetails.email_id_business || '&mdash;' }}
                                        </p>
                                    </div>
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Personal
                                            Email</label>
                                        <p class="text-sm font-bold text-gray-900 px-1">{{ userDetails.email_id_personal
                                            ||
                                            '&mdash;' }}</p>
                                    </div>
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Primary
                                            Phone</label>
                                        <p class="text-sm font-bold text-gray-900 px-1">{{ userDetails.phone_office ||
                                            '&mdash;' }}</p>
                                    </div>
                                </div>
                                <div class="space-y-4">
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Designation</label>
                                        <p class="text-sm font-bold text-gray-900 px-1">{{ userDetails.designation ||
                                            'N/A'
                                            }}</p>
                                    </div>
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Sales
                                            Person NO</label>
                                        <p class="text-sm font-bold text-gray-900 px-1">{{ userDetails.salesperson_no ||
                                            '&mdash;' }}</p>
                                    </div>
                                    <div
                                        class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                        <label
                                            class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Payroll
                                            ID</label>
                                        <p class="text-sm font-bold text-gray-900 px-1">{{ userDetails.payroll_id ||
                                            '&mdash;' }}</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 transition-all hover:shadow-md hover:border-brandAccent/40">
                                <label
                                    class="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1 px-1">Home
                                    Address</label>
                                <p class="text-sm font-bold text-gray-900 px-1 leading-relaxed">{{
                                    userDetails.primary_address || 'No address provided.' }}</p>
                            </div>
                        </div>


                        <div *ngIf="showRolePreview"
                            class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
                            <div
                                class="bg-white w-full max-w-3xl rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden max-h-[98vh]">

                                <div class="px-10 py-7 border-b border-gray-100 flex items-center justify-between">
                                    <div>
                                        <h3 class="text-2xl font-black text-gray-900 tracking-tight">{{
                                            selectedPreviewRoleName }}</h3>
                                        <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">
                                            Permission Matrix Preview</p>
                                    </div>
                                    <button (click)="showRolePreview = false"
                                        class="p-2 text-gray-400 hover:bg-gray-100 rounded-full transition-all">
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12"></path>
                                        </svg>
                                    </button>
                                </div>

                                <div class="flex-1 overflow-auto p-8 bg-gray-50/30 custom-scrollbar">
                                    <div
                                        class="bg-white border border-gray-200 rounded-[2rem] overflow-hidden shadow-sm">
                                        <table class="min-w-full text-sm">
                                            <thead class="bg-gray-50/80 border-b border-gray-100 sticky top-0 z-10">
                                                <tr
                                                    class="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                                    <th class="px-8 py-4 text-left">Entity</th>
                                                    <th class="px-4 py-4 text-center">Create</th>
                                                    <th class="px-4 py-4 text-center">View</th>
                                                    <th class="px-4 py-4 text-center">Update</th>
                                                    <th class="px-4 py-4 text-center">Delete</th>
                                                    <th class="px-4 py-4 text-center">Drops</th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100">
                                                <tr *ngIf="isPreviewLoading">
                                                    <td colspan="6" class="py-20 text-center">
                                                        <div
                                                            class="w-10 h-10 border-4 border-brandPurple/20 border-t-brandPurple rounded-full animate-spin mx-auto mb-4">
                                                        </div>
                                                        <p
                                                            class="text-xs font-bold text-gray-400 uppercase tracking-widest">
                                                            Generating Map...</p>
                                                    </td>
                                                </tr>

                                                <tr *ngFor="let p of previewPermissions"
                                                    class="hover:bg-brandPurple/[0.02] transition-colors">
                                                    <td class="px-8 py-4 font-bold text-gray-700 text-xs">{{ p.entity }}
                                                    </td>
                                                    <td *ngFor="let act of ['create','view','update','delete','drop']"
                                                        class="px-4 py-4">
                                                        <div class="flex items-center justify-center">
                                                            <div class="w-5 h-5 rounded-md border flex items-center justify-center transition-all duration-300"
                                                                [ngClass]="p[act] ? 'bg-brandPurple border-brandPurple shadow-sm shadow-brandPurple/30' : 'bg-gray-100 border-gray-200'">
                                                                <svg *ngIf="p[act]" class="w-3 h-3 text-white"
                                                                    fill="none" stroke="currentColor"
                                                                    viewBox="0 0 24 24">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="4" d="M5 13l4 4L19 7"></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="px-10 py-6 border-t border-gray-100 bg-white flex justify-end">
                                    <button (click)="showRolePreview = false"
                                        class="px-10 py-3 bg-gray-900 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest active:scale-95 transition-all">Close
                                        Preview</button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="activeTab === 'roles'"
                            class="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <div class="space-y-4">
                                <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest ml-1">Current User
                                    Roles</h3>
                                <div class="flex flex-wrap gap-2">
                                    <div *ngFor="let role of currentUserRolesList"
                                        class="flex items-center gap-2 bg-brandPurple/5 border border-brandPurple/10 px-4 py-2 rounded-xl group transition-all">
                                        <span class="text-sm font-bold text-brandPurple">{{ role.role }}</span>
                                        <button class="text-brandPurple/30 hover:text-red-500 transition-colors"
                                            (click)="removeUserRole(role)">
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="space-y-4 pt-4">
                                <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest ml-1 text-center">
                                    Assign New Roles</h3>

                                <input #searchInput (keyup)="0" type="text" placeholder="Search roles..."
                                    class="w-full px-5 py-3 rounded-2xl border border-brandAccent/20 bg-white text-sm shadow-sm focus:ring-2 focus:ring-brandAccent/50 outline-none">

                                <div
                                    class="bg-white rounded-3xl border border-brandAccent/20 shadow-sm overflow-auto max-h-120 custom-scrollbar">
                                    <table class="w-full text-sm">
                                        <thead
                                            class="bg-gray-50 border-b border-brandAccent/10 text-gray-400 uppercase text-[10px] font-black sticky top-0">
                                            <tr>
                                                <th class="px-6 py-4 text-left">Role Name</th>
                                                <th class="px-6 py-4 text-center w-28">Assign</th>
                                                <th class="px-6 py-4 text-center w-24">View</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-50">
                                            <ng-container *ngFor="let role of getSortedAvailableRoles()">
                                                <tr *ngIf="role.role.toLowerCase().includes(searchInput.value.toLowerCase())"
                                                    class="hover:bg-gray-50 transition-colors">
                                                    <td class="px-6 py-4 font-bold text-gray-700">{{ role.role }}</td>
                                                    <td class="px-6 py-4 text-center">
                                                        <button (click)="assignRole(role)"
                                                            class="bg-brandAccent text-white px-4 py-1.5 rounded-lg font-black uppercase text-[10px] tracking-widest hover:bg-brandPurple transition-all">
                                                            Assign
                                                        </button>
                                                    </td>
                                                    <td class="px-6 py-4 text-center">
                                                        <button (click)="previewRolePermissions(role)"
                                                            class="w-10 h-8 flex items-center justify-center rounded-lg border border-purple-200 text-purple-600 bg-purple-50 hover:bg-purple-100 transition-all mx-auto">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                viewBox="0 0 24 24">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2" d="M9 5l7 7-7 7"></path>
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </ng-container>

                                            <!-- Check if any roles match the search -->
                                            <tr
                                                *ngIf="!getSortedAvailableRoles().some(role => role.role.toLowerCase().includes(searchInput.value.toLowerCase()))">
                                                <td colspan="3" class="px-6 py-12 text-center">
                                                    <div class="flex flex-col items-center justify-center gap-2">
                                                        <svg class="w-12 h-12 text-gray-300" fill="none"
                                                            stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="1.5"
                                                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                                                            </path>
                                                        </svg>
                                                        <p class="text-gray-400 font-bold text-sm">No roles found</p>

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!--         <div *ngIf="showRolePreview"
                        class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
                        <div
                            class="bg-white w-full max-w-3xl rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden max-h-[85vh]">

                            <div class="px-10 py-7 border-b border-gray-100 flex items-center justify-between">
                                <div>
                                    <h3 class="text-2xl font-black text-gray-900 tracking-tight">{{
                                        selectedPreviewRoleName }}</h3>
                                    <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">
                                        Permission Overview</p>
                                </div>
                                <button (click)="showRolePreview = false"
                                    class="p-2 text-gray-400 hover:bg-gray-100 rounded-full transition-all">
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>

                            <div class="flex-1 overflow-auto p-8 bg-gray-50/30 custom-scrollbar">
                                <div class="bg-white border border-gray-200 rounded-[2rem] overflow-hidden shadow-sm">
                                    <table class="min-w-full text-sm">
                                        <thead class="bg-gray-50/80 border-b border-gray-100 sticky top-0 z-10">
                                            <tr class="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                                <th class="px-8 py-4 text-left">Entity Level Access</th>
                                                <th class="px-4 py-4 text-center">Create</th>
                                                <th class="px-4 py-4 text-center">View</th>
                                                <th class="px-4 py-4 text-center">Update</th>
                                                <th class="px-4 py-4 text-center">Delete</th>
                                                <th class="px-4 py-4 text-center">Drops</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100">
                                            <tr *ngIf="isPreviewLoading">
                                                <td colspan="6" class="py-20 text-center">
                                                    <div
                                                        class="w-10 h-10 border-4 border-brandPurple/20 border-t-brandPurple rounded-full animate-spin mx-auto mb-4">
                                                    </div>
                                                    <span
                                                        class="text-xs text-gray-400 font-bold uppercase tracking-widest">Building
                                                        Matrix...</span>
                                                </td>
                                            </tr>

                                            <tr *ngFor="let p of previewPermissions"
                                                class="hover:bg-brandPurple/[0.02] transition-colors">
                                                <td class="px-8 py-4 font-bold text-gray-700 text-xs">{{ p.entity }}
                                                </td>
                                                <td *ngFor="let act of ['create','view','update','delete','drop']"
                                                    class="px-4 py-4">
                                                    <div class="flex items-center justify-center">
                                                        <div class="w-5 h-5 rounded-md border flex items-center justify-center transition-all duration-300"
                                                            [ngClass]="p[act] ? 'bg-brandPurple border-brandPurple shadow-brandPurple/30 shadow-sm' : 'bg-gray-100 border-gray-200'">
                                                            <svg *ngIf="p[act]" class="w-3.5 h-3.5 text-white"
                                                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="4" d="M5 13l4 4L19 7"></path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="px-10 py-6 border-t border-gray-100 bg-white flex justify-end">
                                <button (click)="showRolePreview = false"
                                    class="px-10 py-3 bg-gray-900 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest active:scale-95 transition-all">Close
                                    Details</button>
                            </div>
                        </div>
                    </div> -->


                        <!-- Sessions Tab Content -->
                        <div *ngIf="activeTab === 'sessions'"
                            class="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <div class="flex items-center justify-between px-1">
                                <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest">Active Device
                                    Sessions</h3>
                                <button (click)="clearSessions()"
                                    class="px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 text-[10px] font-black uppercase tracking-widest rounded-xl shadow-sm hover:shadow transition-all active:scale-95 flex items-center gap-2">
                                    Terminate All Sessions
                                </button>
                            </div>
                            <div
                                class="bg-white rounded-3xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 overflow-hidden">
                                <table class="w-full text-xs">
                                    <thead
                                        class="bg-gray-50 border-b border-brandAccent/10 text-gray-400 uppercase font-black tracking-tighter">
                                        <tr>
                                            <th class="px-6 py-4 text-left">Module</th>
                                            <!--  <th class="px-6 py-4 text-left">IP/Device</th> -->
                                            <th class="px-6 py-4 text-right pr-8">Expires At</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-50">
                                        <tr *ngFor="let session of userSessions"
                                            class="hover:bg-gray-50/50 transition-colors">
                                            <td class="px-6 py-4 font-black text-gray-900">{{ session.module }}</td>
                                            <!--  <td class="px-6 py-4 text-gray-500 font-medium">{{ session.ip_address }}</td> -->
                                            <td
                                                class="px-6 py-4 text-right pr-8 text-gray-400 font-bold uppercase tracking-tighter">
                                                {{ session.formattedExpires }}
                                            </td>
                                        </tr>
                                        <tr *ngIf="userSessions.length === 0 && !isSessionLoading">
                                            <td colspan="3"
                                                class="px-6 py-12 text-center text-gray-400 font-medium italic">
                                                No active sessions tracked.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Locations Tab Content -->
                        <div *ngIf="activeTab === 'locations'"
                            class="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <div
                                class="flex items-center justify-between gap-4 p-4 bg-brandAccent/5 border border-brandAccent/10 rounded-2xl mb-8">

                                <!-- SEARCHABLE LOCATION DROPDOWN -->
                                <div class="relative w-full">

                                    <!-- BUTTON -->
                                    <button type="button"
                                        (click)="showAssignLocationDropdown = !showAssignLocationDropdown"
                                        class="w-full flex items-center justify-between text-sm py-2 pl-3 pr-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-brandAccent/20 transition-all">

                                        <span class="truncate">
                                            {{
                                            selectedAssignLocationName
                                            ? selectedAssignLocationName
                                            : 'Assign a new store location...'
                                            }}
                                        </span>

                                        <svg class="w-4 h-4 ml-3 text-gray-500" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">

                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M19 9l-7 7-7-7">
                                            </path>

                                        </svg>

                                    </button>

                                    <!-- DROPDOWN -->
                                    <div *ngIf="showAssignLocationDropdown"
                                        class="absolute left-0 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-hidden">

                                        <!-- SEARCH -->
                                        <div class="p-2 border-b border-gray-100">

                                            <input type="text" [(ngModel)]="assignLocationSearch"
                                                placeholder="Search location..."
                                                class="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brandAccent/20">

                                        </div>

                                        <!-- OPTIONS -->
                                        <div class="max-h-[240px] overflow-y-auto">

                                            <div *ngFor="let loc of availableLocationsList"
                                                [class.hidden]="assignLocationSearch && !(loc.base_location || loc.name)?.toLowerCase().includes(assignLocationSearch.toLowerCase())"
                                                class="px-4 py-3 h-12 text-sm hover:bg-brandAccent/10 cursor-pointer truncate flex items-center"
                                                (click)="selectedAssignLocationId = (loc.location_id || loc.id);
                             selectedAssignLocationName = (loc.base_location || loc.name);
                             showAssignLocationDropdown = false">

                                                {{ loc.base_location || loc.name }}

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <!-- BUTTON -->
                                <button
                                    class="bg-brandAccent hover:bg-brandPurple text-white px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all disabled:opacity-30 whitespace-nowrap"
                                    (click)="selectedAssignLocationId ? addBaseLocation(selectedAssignLocationId, '') : null"
                                    [disabled]="!selectedAssignLocationId">

                                    Assign Location

                                </button>

                            </div>

                            <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest px-1">Managed Base
                                Locations</h3>
                            <div *ngIf="message1" [ngClass]="{
        'bg-green-50 border-green-500 text-green-700': messageColor === 'green',
        'bg-yellow-50 border-yellow-500 text-yellow-700': messageColor === 'yellow',
        'bg-red-50 border-red-500 text-red-700': messageColor === 'red'
    }" class="mb-4 border-l-4 p-3 rounded-md">
                                <p class="text-sm font-bold">{{ message1 }}</p>
                            </div>
                            <div class="grid grid-cols-1 gap-3">
                                <div *ngFor="let location of baseLocationsList"
                                    class="flex items-center justify-between bg-white p-5 rounded-2xl border border-brandAccent/20 shadow-sm shadow-brandAccent/5 group hover:shadow-md transition-all">
                                    <div class="flex items-center gap-4">
                                        <div
                                            class="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 group-hover:bg-brandAccent/10 group-hover:text-brandAccent transition-colors">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                                                </path>
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                            </svg>
                                        </div>
                                        <span
                                            class="font-black text-gray-900 group-hover:text-brandPurple transition-colors tracking-tight">{{
                                            location.base_location || location.name }}</span>
                                    </div>

                                    <button
                                        class="text-red-400 hover:text-red-600 p-2 rounded-lg hover:bg-red-50 transition-all"
                                        (click)="removeBaseLocation(location.base_location_id || location.location_id || location.id)">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                            </path>
                                        </svg>
                                    </button>
                                </div>
                                <div *ngIf="baseLocationsList.length === 0 && !isLocationLoading"
                                    class="py-12 text-center border-2 border-dashed border-gray-100 rounded-3xl">
                                    <p class="text-gray-400 text-sm font-medium">No locations assigned.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Create User Modal -->
            <div *ngIf="isCreateUser"
                class="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-4xl rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-[92vh] animate-in fade-in zoom-in duration-300">
                    <!-- Modal Header -->
                    <div class="px-8 py-5 border-b border-gray-100 bg-white flex justify-between items-center relative">
                        <div
                            class="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brandPurple to-brandAccent">
                        </div>
                        <div>
                            <h2 class="text-2xl font-extrabold text-gray-900 tracking-tight">Create New User</h2>
                            <p class="text-gray-500 text-sm mt-0.5">Fill in the information below to register a new user
                                account.</p>
                        </div>
                        <button
                            class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all duration-200 focus:outline-none"
                            (click)="closeCreateForm()">
                            <span class="text-3xl font-light">&times;</span>
                        </button>
                    </div>

                    <!-- Modal Body -->
                    <div class="p-8 overflow-y-auto bg-gray-50/30">
                        <!-- Error Message -->
                        <div *ngIf="errorMessage"
                            class="mb-6 bg-red-50 border border-red-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                            <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <p class="text-red-700 text-sm font-semibold">{{ errorMessage }}</p>
                        </div>


                        <div *ngIf="createmessage"
                            class="mb-6 bg-green-50 border border-green-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                            <svg class="w-5 h-5 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <p class="text-green-700 text-sm font-semibold">{{ createmessage }}</p>
                        </div>
                        <div class="space-y-10">
                            <!-- Basic Information Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-brandPurple/10 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-brandPurple" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Basic Information</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Full Name
                                            <span
                                                [style.color]="userFormObj.name?.trim().length >= 2 && userFormObj.name?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                        </label>

                                        <input type="text" [(ngModel)]="userFormObj.name" name="fullNameCreate"
                                            #fullNameCreate="ngModel" required maxlength="40"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="userFormObj.name?.trim().length > 0 && (userFormObj.name?.trim().length < 2 || userFormObj.name?.trim().length > 40)"
                                            [class.border-gray-200]="!userFormObj.name || userFormObj.name?.trim().length === 0 || (userFormObj.name?.trim().length >= 2 && userFormObj.name?.trim().length <= 40)"
                                            placeholder="Enter Full Name">

                                        <p *ngIf="userFormObj.name?.trim().length > 0 && (userFormObj.name?.trim().length < 2 || userFormObj.name?.trim().length > 40)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Name should be between 2 and 40 characters.
                                        </p>
                                    </div>

                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Username
                                            <span
                                                [style.color]="userFormObj.username?.trim().length >= 2 && userFormObj.username?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                        </label>

                                        <input type="text" [(ngModel)]="userFormObj.username" name="usernameCreate"
                                            #usernameCreate="ngModel" required maxlength="40"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="userFormObj.username?.trim().length > 0 && (userFormObj.username?.trim().length < 2 || userFormObj.username?.trim().length > 40)"
                                            [class.border-gray-200]="!userFormObj.username || userFormObj.username?.trim().length === 0 || (userFormObj.username?.trim().length >= 2 && userFormObj.username?.trim().length <= 40)"
                                            placeholder="john.doe">

                                        <p *ngIf="userFormObj.username?.trim().length > 0 && (userFormObj.username?.trim().length < 2 || userFormObj.username?.trim().length > 40)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Username should be between 2 and 40 characters.
                                        </p>
                                    </div>
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Password
                                            <span class="text-red-500">*</span>
                                        </label>
                                        <div class="relative">
                                            <input [type]="passwordVisible ? 'text' : 'password'"
                                                [(ngModel)]="userFormObj.password" name="passwordCreate"
                                                #passwordCreate="ngModel" required
                                                (input)="checkPasswordPolicy(userFormObj.password)"
                                                class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 pr-12"
                                                [class.border-red-500]="policyErrors.length > 0 && userFormObj.password"
                                                [class.border-green-500]="policyErrors.length === 0 && userFormObj.password && userFormObj.password.length >= 5"
                                                [class.border-gray-200]="!userFormObj.password"
                                                placeholder="Enter password">
                                            <button (click)="passwordVisible = !passwordVisible"
                                                class="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-brandPurple hover:bg-gray-50 rounded-lg transition-colors">
                                                <svg *ngIf="!passwordVisible" class="w-5 h-5" fill="none"
                                                    stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                                <svg *ngIf="passwordVisible" class="w-5 h-5" fill="none"
                                                    stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7 1.274-4.057-5.064-7-9.542-7 .539 0 1.062.051 1.564.148m11.356 11.356l-1.144-1.144m1.144 1.144a9 9 0 001.564-1.148M15 12a3 3 0 11-6 0 3 3 0 016 0zm-5 1a3 3 0 110-6 3 3 0 010 6zM22 22l-2-2" />
                                                </svg>
                                            </button>
                                        </div>

                                        <!-- Policy Warning Messages -->
                                        <div *ngIf="policyErrors.length > 0 && userFormObj.password"
                                            class="space-y-1 mt-1">
                                            <div *ngFor="let err of policyErrors"
                                                class="text-xs text-red-500 font-medium px-1">
                                                • {{ err }}
                                            </div>
                                        </div>

                                        <!-- Success Message -->
                                        <!--   <div *ngIf="policyErrors.length === 0 && userFormObj.password && userFormObj.password.length >= 5"
                                        class="text-xs text-green-500 font-medium px-1 mt-1">
                                        ✓ Password meets all requirements
                                    </div> -->

                                        <!-- Built-in Angular validation errors (optional, can remove) -->
                                        <div
                                            *ngIf="passwordCreate.invalid && (passwordCreate.dirty || passwordCreate.touched) && policyErrors.length === 0">
                                            <p *ngIf="passwordCreate.errors?.['required']"
                                                class="text-[10px] text-red-500 font-bold px-1">
                                                Password is required.
                                            </p>
                                            <p *ngIf="passwordCreate.errors?.['minlength']"
                                                class="text-[10px] text-red-500 font-bold px-1">
                                                Password must be minimum 5 characters long.
                                            </p>
                                        </div>

                                        <!-- Strength Indicator -->
                                        <div class="mt-2 flex gap-1.5 h-1 px-1">
                                            <div class="flex-1 rounded-full transition-colors duration-500"
                                                [class.bg-red-400]="userFormObj.password?.length > 0 && userFormObj.password?.length < 5"
                                                [class.bg-yellow-400]="userFormObj.password?.length >= 5 && userFormObj.password?.length <= 7"
                                                [class.bg-green-400]="userFormObj.password?.length >= 8 && policyErrors.length === 0"
                                                [class.bg-gray-200]="!userFormObj.password">
                                            </div>
                                            <div class="flex-1 rounded-full transition-colors duration-500"
                                                [class.bg-yellow-400]="userFormObj.password?.length >= 5 && userFormObj.password?.length <= 7"
                                                [class.bg-green-400]="userFormObj.password?.length >= 8 && policyErrors.length === 0"
                                                [class.bg-gray-200]="userFormObj.password?.length < 5 || !userFormObj.password">
                                            </div>
                                            <div class="flex-1 rounded-full transition-colors duration-500"
                                                [class.bg-green-400]="userFormObj.password?.length >= 8 && policyErrors.length === 0"
                                                [class.bg-gray-200]="userFormObj.password?.length < 8 || !userFormObj.password">
                                            </div>
                                            <div class="flex-1 rounded-full transition-colors duration-500"
                                                [class.bg-green-500]="userFormObj.password?.length >= 10 && policyErrors.length === 0"
                                                [class.bg-gray-200]="userFormObj.password?.length < 10 || !userFormObj.password">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Confirm Password
                                            <span
                                                [style.color]="(userFormObj.password && userFormObj.confirmPassword && userFormObj.password === userFormObj.confirmPassword) ? '#10b981' : '#ef4444'">*</span>
                                        </label>
                                        <div class="relative">
                                            <input [type]="confirmPasswordVisible ? 'text' : 'password'"
                                                [(ngModel)]="userFormObj.confirmPassword"
                                                class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 pr-12"
                                                [class.border-green-500]="userFormObj.password && userFormObj.confirmPassword && userFormObj.password === userFormObj.confirmPassword"
                                                [class.border-gray-200]="!userFormObj.confirmPassword"
                                                placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;">
                                            <p *ngIf="userFormObj.confirmPassword && userFormObj.password !== userFormObj.confirmPassword"
                                                class="text-[10px] text-red-500 font-bold px-1">
                                                Passwords do not match!
                                            </p>
                                            <button (click)="confirmPasswordVisible = !confirmPasswordVisible"
                                                class="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-brandPurple hover:bg-gray-50 rounded-lg transition-colors">
                                                <svg *ngIf="!confirmPasswordVisible" class="w-5 h-5" fill="none"
                                                    stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                                <svg *ngIf="confirmPasswordVisible" class="w-5 h-5" fill="none"
                                                    stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7 1.274-4.057-5.064-7-9.542-7 .539 0 1.062.051 1.564.148m11.356 11.356l-1.144-1.144m1.144 1.144a9 9 0 001.564-1.148M15 12a3 3 0 11-6 0 3 3 0 016 0zm-5 1a3 3 0 110-6 3 3 0 010 6zM22 22l-2-2" />
                                                </svg>
                                            </button>

                                        </div>
                                    </div>
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Business Email
                                            <span
                                                [class.text-green-500]="emailCreate.valid && (emailCreate.dirty || emailCreate.touched)"
                                                [class.text-red-500]="!(emailCreate.valid && (emailCreate.dirty || emailCreate.touched))">
                                                *
                                            </span>
                                        </label>

                                        <!-- Updated the pattern attribute below -->
                                        <input type="email" [(ngModel)]="userFormObj.recovery_email" name="emailCreate"
                                            #emailCreate="ngModel" required
                                            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="emailCreate.invalid && (emailCreate.dirty || emailCreate.touched)"
                                            [class.border-gray-200]="!(emailCreate.invalid && (emailCreate.dirty || emailCreate.touched))"
                                            placeholder="john.doe@example.com">

                                        <p *ngIf="emailCreate.invalid && (emailCreate.dirty || emailCreate.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid email! E.g (xx@xxx.xxx)
                                        </p>
                                    </div>
                                    <!--                               <div class="space-y-1.5">
    <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Status</label>
    <div class="relative">
        <select [(ngModel)]="userFormObj.status"
            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent appearance-none hover:border-gray-300 text-gray-800">
            <option value="" disabled>Select Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400">
            <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
        </div>
    </div>
</div> -->
                                </div>
                            </section>

                            <!-- Contact Details Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-brandAccent/10 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-brandAccent" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Contact Details</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Work
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_office" name="workPhoneCreate"
                                            #workPhoneCreate="ngModel" pattern="^(\(\d{3}\)|\d{3})[-]?\d{3}[-]?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="workPhoneCreate.invalid && (workPhoneCreate.dirty || workPhoneCreate.touched)"
                                            [class.border-gray-200]="!(workPhoneCreate.invalid && (workPhoneCreate.dirty || workPhoneCreate.touched))"
                                            placeholder="308-135-7895">
                                        <p *ngIf="workPhoneCreate.invalid && (workPhoneCreate.dirty || workPhoneCreate.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number! (E.g 308-135-7895 or 3081357895)
                                        </p>
                                    </div>

                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Mobile
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_mobile"
                                            name="mobilePhoneCreate" #mobilePhoneCreate="ngModel"
                                            pattern="^(\(\d{3}\)|\d{3})[-]?\d{3}[-]?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="mobilePhoneCreate.invalid && (mobilePhoneCreate.dirty || mobilePhoneCreate.touched)"
                                            [class.border-gray-200]="!(mobilePhoneCreate.invalid && (mobilePhoneCreate.dirty || mobilePhoneCreate.touched))"
                                            placeholder="308-135-7895">
                                        <p *ngIf="mobilePhoneCreate.invalid && (mobilePhoneCreate.dirty || mobilePhoneCreate.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number! (E.g 308-135-7895 or 3081357895)
                                        </p>
                                    </div>

                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Home
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_residence"
                                            name="homePhoneCreate" #homePhoneCreate="ngModel"
                                            pattern="^(\(\d{3}\)|\d{3})[-]?\d{3}[-]?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="homePhoneCreate.invalid && (homePhoneCreate.dirty || homePhoneCreate.touched)"
                                            [class.border-gray-200]="!(homePhoneCreate.invalid && (homePhoneCreate.dirty || homePhoneCreate.touched))"
                                            placeholder="308-135-7895">
                                        <p *ngIf="homePhoneCreate.invalid && (homePhoneCreate.dirty || homePhoneCreate.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number! (E.g 308-135-7895 or 3081357895)
                                        </p>
                                    </div>
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Personal
                                            Email</label>
                                        <input type="email" [(ngModel)]="userFormObj.email_id_personal"
                                            name="personalEmailCreate" #personalEmailCreate="ngModel"
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="personalEmailCreate.invalid && (personalEmailCreate.dirty || personalEmailCreate.touched)"
                                            [class.border-gray-200]="!(personalEmailCreate.invalid && (personalEmailCreate.dirty || personalEmailCreate.touched))"
                                            placeholder="personal.email@gmail.com">
                                        <p *ngIf="personalEmailCreate.invalid && (personalEmailCreate.dirty || personalEmailCreate.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid email! E.g (xx@xxx.xxx)
                                        </p>
                                    </div>
                                    <div class="col-span-1 md:col-span-2 space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Primary
                                            Address</label>
                                        <input type="text" [(ngModel)]="userFormObj.primary_address"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="123 Main St, Suite 100, City, State, Zip">
                                    </div>
                                </div>
                            </section>

                            <!-- Other Details Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Other Details</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Designation</label>
                                        <input type="text" [(ngModel)]="userFormObj.designation"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="e.g. System Administrator">
                                    </div>
                                    <div class="space-y-1.5">
                                        <div class="flex items-center gap-2 px-1">
                                            <label
                                                class="text-xs font-bold text-gray-500 uppercase tracking-wider">Sales
                                                Person
                                                No</label>
                                            <div class="group relative inline-block">
                                                <svg class="w-3.5 h-3.5 text-gray-400 cursor-help" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                                <div
                                                    class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] rounded shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
                                                    Internal sales identifier. Maximum 6 characters.
                                                </div>
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="userFormObj.salesperson_no" maxlength="6"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="e.g. S12345">
                                    </div>
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Payroll
                                            ID</label>
                                        <input type="text" [(ngModel)]="userFormObj.payroll_id"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="Enter Payroll ID">
                                    </div>
                                    <div class="space-y-1.5">
                                        <div class="flex items-center gap-2 px-1">
                                            <label
                                                class="text-xs font-bold text-gray-500 uppercase tracking-wider">AS400
                                                User Name</label>
                                            <div class="group relative inline-block">
                                                <svg class="w-3.5 h-3.5 text-gray-400 cursor-help" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                                <div
                                                    class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] rounded shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
                                                    Legacy system synchronization username.
                                                </div>
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="userFormObj.as400_user_name"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="AS400 Username">
                                    </div>
                                    <div class="col-span-1 md:col-span-2 pt-2">
                                        <label
                                            class="flex items-center gap-4 cursor-pointer group w-fit p-1 rounded-lg hover:bg-gray-100/50 transition-colors">
                                            <div class="relative">
                                                <input type="checkbox" [(ngModel)]="userFormObj.is_service_accounts"
                                                    class="sr-only peer">
                                                <div
                                                    class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-brandAccent transition-colors duration-200">
                                                </div>
                                                <div
                                                    class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 peer-checked:translate-x-5">
                                                </div>
                                            </div>
                                            <div>
                                                <span class="text-sm font-bold text-gray-700">Is Service Account</span>
                                                <p class="text-[11px] text-gray-400 font-medium">Use for background
                                                    tasks
                                                    and automated interfaces.</p>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                    <!-- Modal Footer -->
                    <div
                        class="px-8 py-5 border-t border-gray-100 bg-white flex justify-end gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.02)]">
                        <button
                            class="px-6 py-2.5 border border-gray-200 text-gray-600 rounded-xl text-sm font-bold hover:bg-gray-50 hover:border-gray-300 transition-all active:scale-95 flex items-center gap-2"
                            (click)="closeCreateForm()">
                            Cancel
                        </button>
                        <button
                            class="px-8 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl text-sm font-bold shadow-lg shadow-brandAccent/25 transition-all hover:shadow-brandAccent/40 hover:-translate-y-0.5 active:scale-95 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
                            (click)="saveUser()" [disabled]="
        (fullNameCreate.invalid && (fullNameCreate.dirty || fullNameCreate.touched)) ||
        (usernameCreate.invalid && (usernameCreate.dirty || usernameCreate.touched)) ||
        (passwordCreate.invalid && (passwordCreate.dirty || passwordCreate.touched)) ||
        (emailCreate.invalid && (emailCreate.dirty || emailCreate.touched)) ||
        (workPhoneCreate.invalid && (workPhoneCreate.dirty || workPhoneCreate.touched)) ||
        (mobilePhoneCreate.invalid && (mobilePhoneCreate.dirty || mobilePhoneCreate.touched)) ||
        (homePhoneCreate.invalid && (homePhoneCreate.dirty || homePhoneCreate.touched)) ||
        (personalEmailCreate.invalid && (personalEmailCreate.dirty || personalEmailCreate.touched)) ||
        (userFormObj.password !== userFormObj.confirmPassword && userFormObj.confirmPassword?.length > 0)
    ">
                            <span>Save User</span>
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>


            <!-- Update Profile Modal -->
            <div *ngIf="isUpdateProfile"
                class="fixed inset-0 z-[160] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-4xl rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-[92vh] animate-in fade-in zoom-in duration-300">
                    <!-- Modal Header -->
                    <div class="px-8 py-5 border-b border-gray-100 bg-white flex justify-between items-center relative">
                        <div
                            class="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brandPurple to-brandAccent">
                        </div>
                        <div>
                            <h2 class="text-2xl font-extrabold text-gray-900 tracking-tight">Update User Profile</h2>
                            <p class="text-gray-500 text-sm mt-0.5">Modify account details for <span
                                    class="font-bold text-brandPurple">{{ userDetails.name }}</span></p>
                        </div>
                        <button
                            class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all duration-200 focus:outline-none"
                            (click)="isUpdateProfile = false">
                            <span class="text-3xl font-light">&times;</span>
                        </button>
                    </div>

                    <!-- Modal Body -->
                    <div class="p-8 overflow-y-auto bg-gray-50/30">
                        <!-- Error Message -->
                        <div *ngIf="errorMessage"
                            class="mb-6 bg-red-50 border border-red-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                            <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <p class="text-red-700 text-sm font-semibold">{{ errorMessage }}</p>
                        </div>
                        <!-- Success Message (New) -->
                        <div *ngIf="message1"
                            class="mb-6 bg-green-50 border border-green-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                            <svg class="w-5 h-5 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <p class="text-green-700 text-sm font-semibold">{{ message1 }}</p>
                        </div>

                        <div class="space-y-10">
                            <!-- Basic Information Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-brandPurple/10 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-brandPurple" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Basic Information</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <!-- Full Name Section -->
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Full Name
                                            <span
                                                [style.color]="userFormObj.name?.trim().length >= 2 && userFormObj.name?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                        </label>

                                        <input type="text" [(ngModel)]="userFormObj.name" name="fullName"
                                            #fullName="ngModel" required maxlength="40"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="userFormObj.name?.trim().length > 0 && (userFormObj.name?.trim().length < 2 || userFormObj.name?.trim().length > 40)"
                                            [class.border-gray-200]="!userFormObj.name || userFormObj.name?.trim().length === 0 || (userFormObj.name?.trim().length >= 2 && userFormObj.name?.trim().length <= 40)"
                                            placeholder="Enter Full Name">

                                        <p *ngIf="userFormObj.name?.trim().length > 0 && (userFormObj.name?.trim().length < 2 || userFormObj.name?.trim().length > 40)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Name should be between 2 and 40 characters.
                                        </p>
                                    </div>
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Username
                                            <span
                                                [style.color]="userFormObj.username?.trim().length >= 2 && userFormObj.username?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                        </label>

                                        <input type="text" [(ngModel)]="userFormObj.username" name="username"
                                            #username="ngModel" required maxlength="40"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="userFormObj.username?.trim().length > 0 && (userFormObj.username?.trim().length < 2 || userFormObj.username?.trim().length > 40)"
                                            [class.border-gray-200]="!userFormObj.username || userFormObj.username?.trim().length === 0 || (userFormObj.username?.trim().length >= 2 && userFormObj.username?.trim().length <= 40)"
                                            placeholder="Enter Username">

                                        <p *ngIf="userFormObj.username?.trim().length > 0 && (userFormObj.username?.trim().length < 2 || userFormObj.username?.trim().length > 40)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Username should be between 2 and 40 characters.
                                        </p>
                                    </div>
                                    <!-- Business Email Section -->
                                    <div class="space-y-1.5">
                                        <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">
                                            Business Email
                                            <!-- Dynamic color based on the 'email' template variable validity -->
                                            <span [ngClass]="email.valid ? 'text-green-500' : 'text-red-500'">*</span>
                                        </label>
                                        <input type="email" [(ngModel)]="userFormObj.email_id_business" name="email"
                                            #email="ngModel" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="email.invalid && (email.dirty || email.touched)"
                                            [class.border-gray-200]="!(email.invalid && (email.dirty || email.touched))"
                                            placeholder="john.doe@example.com">

                                        <p *ngIf="email.invalid && (email.dirty || email.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid email! E.g (xx@xxx.xxx)
                                        </p>
                                    </div>

                                </div>
                            </section>

                            <!-- Contact Details Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-brandAccent/10 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-brandAccent" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Contact Details</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <!-- Work Phone Section -->
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Work
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_office" name="workPhone"
                                            #workPhone="ngModel"
                                            pattern="^(\(\d{3}\)-|\d{3}-|\d{6}-|\d{3})?\d{3}-?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="workPhone.invalid && (workPhone.dirty || workPhone.touched)"
                                            [class.border-gray-200]="!(workPhone.invalid && (workPhone.dirty || workPhone.touched))"
                                            placeholder="308-135-7895">

                                        <p *ngIf="workPhone.invalid && (workPhone.dirty || workPhone.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number (E.g (308)-135-7895 or 3081357895)
                                        </p>
                                    </div>

                                    <!-- Mobile Phone Section -->
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Mobile
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_mobile" name="mobile"
                                            #mobile="ngModel" pattern="^(\(\d{3}\)-|\d{3}-|\d{6}-|\d{3})?\d{3}-?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="mobile.invalid && (mobile.dirty || mobile.touched)"
                                            [class.border-gray-200]="!(mobile.invalid && (mobile.dirty || mobile.touched))"
                                            placeholder="308-135-7895">

                                        <p *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number (E.g (308)-135-7895 or 3081357895)
                                        </p>
                                    </div>

                                    <!-- Home Phone Section -->
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Home
                                            Phone</label>
                                        <input type="text" [(ngModel)]="userFormObj.phone_residence" name="homePhone"
                                            #homePhone="ngModel"
                                            pattern="^(\(\d{3}\)-|\d{3}-|\d{6}-|\d{3})?\d{3}-?\d{4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="homePhone.invalid && (homePhone.dirty || homePhone.touched)"
                                            [class.border-gray-200]="!(homePhone.invalid && (homePhone.dirty || homePhone.touched))"
                                            placeholder="308-135-7895">

                                        <p *ngIf="homePhone.invalid && (homePhone.dirty || homePhone.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid phone number (E.g (308)-135-7895 or 3081357895)
                                        </p>
                                    </div>

                                    <!-- Personal Email Section -->
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Personal
                                            Email</label>
                                        <input type="email" [(ngModel)]="userFormObj.email_id_personal"
                                            name="personalEmail" #personalEmail="ngModel"
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="personalEmail.invalid && (personalEmail.dirty || personalEmail.touched)"
                                            [class.border-gray-200]="!(personalEmail.invalid && (personalEmail.dirty || personalEmail.touched))"
                                            placeholder="personal.email@gmail.com">

                                        <p *ngIf="personalEmail.invalid && (personalEmail.dirty || personalEmail.touched)"
                                            class="text-[10px] text-red-500 font-bold px-1 animate-in slide-in-from-top-1 duration-200">
                                            Invalid email! E.g (xx@xxx.xxx)
                                        </p>
                                    </div>
                                    <div class="col-span-1 md:col-span-2 space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Primary
                                            Address</label>
                                        <input type="text" [(ngModel)]="userFormObj.primary_address"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="123 Main St, Suite 100, City, State, Zip">
                                    </div>
                                </div>
                            </section>

                            <!-- Other Details Section -->
                            <section>
                                <div class="flex items-center gap-3 mb-6">
                                    <div class="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center">
                                        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                                            </path>
                                        </svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-800">Other Details</h3>
                                    <div class="flex-1 h-px bg-gray-200 ml-2"></div>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Designation</label>
                                        <input type="text" [(ngModel)]="userFormObj.designation"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="e.g. System Administrator">
                                    </div>
                                    <div class="space-y-1.5">
                                        <div class="flex items-center gap-2 px-1">
                                            <label
                                                class="text-xs font-bold text-gray-500 uppercase tracking-wider">Sales Person
                                                No</label>
                                            <div class="group relative inline-block">
                                                <svg class="w-3.5 h-3.5 text-gray-400 cursor-help" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                                <div
                                                    class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] rounded shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
                                                    Internal sales identifier. Maximum 6 characters.
                                                </div>
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="userFormObj.salesperson_no" maxlength="6"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="e.g. S12345">
                                    </div>
                                    <div class="space-y-1.5">
                                        <label
                                            class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Payroll
                                            ID</label>
                                        <input type="text" [(ngModel)]="userFormObj.payroll_id"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="Enter Payroll ID">
                                    </div>
                                    <div class="space-y-1.5">
                                        <div class="flex items-center gap-2 px-1">
                                            <label
                                                class="text-xs font-bold text-gray-500 uppercase tracking-wider">AS400
                                                User Name</label>
                                            <div class="group relative inline-block">
                                                <svg class="w-3.5 h-3.5 text-gray-400 cursor-help" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                                <div
                                                    class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-900 text-white text-[10px] rounded shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
                                                    Legacy system synchronization username.
                                                </div>
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="userFormObj.as400_user_name"
                                            class="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10 focus:border-brandAccent hover:border-gray-300"
                                            placeholder="AS400 Username">
                                    </div>
                                    <!--  <div class="col-span-1 md:col-span-2 pt-2">
                                    <label
                                        class="flex items-center gap-4 cursor-pointer group w-fit p-1 rounded-lg hover:bg-gray-100/50 transition-colors">
                                        <div class="relative">
                                            <input type="checkbox" [(ngModel)]="userFormObj.is_service_accounts"
                                                class="sr-only peer">
                                            <div
                                                class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-brandAccent transition-colors duration-200">
                                            </div>
                                            <div
                                                class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 peer-checked:translate-x-5">
                                            </div>
                                        </div>
                                        <div>
                                            <span class="text-sm font-bold text-gray-700">Is Service Account</span>
                                            <p class="text-[11px] text-gray-400 font-medium">Use for background tasks
                                                and automated interfaces.</p>
                                        </div>
                                    </label>
                                </div> -->
                                </div>
                            </section>
                        </div>
                    </div>

                    <!-- Modal Footer -->
                    <div
                        class="px-8 py-5 border-t border-gray-100 bg-white flex justify-end gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.02)]">
                        <button
                            class="px-6 py-2.5 border border-gray-200 text-gray-600 rounded-xl text-sm font-bold hover:bg-gray-50 hover:border-gray-300 transition-all active:scale-95 flex items-center gap-2"
                            (click)="isUpdateProfile = false">
                            Cancel
                        </button>
                        <button
                            class="px-8 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl text-sm font-bold shadow-lg shadow-brandAccent/25 transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            (click)="updateUserDetails()" [disabled]="
        isUpdating ||
        !hasFormChanges() ||
        (fullName.invalid && (fullName.dirty || fullName.touched)) ||
        (email.invalid && (email.dirty || email.touched)) ||
        (workPhone.invalid && (workPhone.dirty || workPhone.touched)) ||
        (mobile.invalid && (mobile.dirty || mobile.touched)) ||
        (homePhone.invalid && (homePhone.dirty || homePhone.touched)) ||
        (personalEmail.invalid && (personalEmail.dirty || personalEmail.touched))
    ">

                            <span>{{ isUpdating ? 'Updating...' : 'Update Profile' }}</span>

                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>

                        </button>
                    </div>
                </div>
            </div>

            <!-- Update Password Modal -->
            <div class="fixed inset-0 z-[160] overflow-y-auto" *ngIf="isUpdatePassword">
                <div class="flex items-center justify-center min-h-screen p-4 text-center">
                    <div class="fixed inset-0 bg-gray-900/60 backdrop-blur-md transition-opacity"></div>

                    <div
                        class="relative bg-white rounded-[2rem] text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full border border-brandAccent/20 animate-in zoom-in-95 duration-300">
                        <div
                            class="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brandPurple via-brandPurpleDark to-brandAccent">
                        </div>

                        <div class="px-10 py-8">
                            <div class="flex items-center justify-between mb-8">
                                <div>
                                    <h3 class="text-2xl font-black text-gray-900 tracking-tight">Update Password</h3>
                                    <p class="text-sm text-gray-500 mt-1">Change credentials for <span
                                            class="font-bold text-brandPurple">{{ userDetails.username }}</span></p>
                                </div>
                                <button (click)="closeUpdatePassword()"
                                    class="p-3 bg-gray-50 hover:bg-gray-100 rounded-2xl text-gray-400 hover:text-gray-600 transition-all active:scale-90">
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>

                            <!-- Success Message -->
                            <div *ngIf="message"
                                class="mb-6 bg-green-50 border border-green-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                                <svg class="w-5 h-5 text-green-500 flex-shrink-0" fill="currentColor"
                                    viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <p class="text-green-700 text-sm font-semibold">{{ message }}</p>
                            </div>

                            <!-- Error Message -->
                            <div *ngIf="errorMessage"
                                class="mb-6 bg-red-50 border border-red-100 p-4 rounded-xl flex items-center gap-3 animate-in slide-in-from-top-2 duration-300">
                                <svg class="w-5 h-5 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <p class="text-red-700 text-sm font-semibold">{{ errorMessage }}</p>
                            </div>

                            <div class="space-y-6">
                                <!-- New Password -->
                                <div class="space-y-1.5 px-1">
                                    <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">New
                                        Password <span class="text-red-500">*</span></label>
                                    <div class="relative flex items-center">
                                        <input [type]="passwordVisible ? 'text' : 'password'"
                                            [(ngModel)]="passwordFormObj.new_password"
                                            (input)="checkPasswordPolicy(passwordFormObj.new_password)"
                                            placeholder="Enter new strong password"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="policyErrors.length > 0 && passwordFormObj.new_password"
                                            [class.border-green-500]="policyErrors.length === 0 && passwordFormObj.new_password && passwordFormObj.new_password.length >= 5"
                                            [class.border-brandAccent/10]="!passwordFormObj.new_password">
                                        <button (click)="passwordVisible = !passwordVisible"
                                            class="absolute right-4 text-gray-400 hover:text-brandPurple transition-colors p-1 focus:outline-none">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                *ngIf="!passwordVisible">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                *ngIf="passwordVisible">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 012.23-4.04m4.845-1.761A9.959 9.959 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21m-6.875-10.125A3.375 3.375 0 1110.5 13.5l3.375-3.375z" />
                                            </svg>
                                        </button>
                                    </div>

                                    <!-- Policy Warning Messages -->
                                    <div *ngIf="policyErrors.length > 0 && passwordFormObj.new_password"
                                        class="space-y-1 mt-2">
                                        <div *ngFor="let err of policyErrors"
                                            class="text-xs text-red-500 font-medium px-1">
                                            • {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Confirm Password -->
                                <div class="space-y-1.5 px-1">
                                    <label class="text-xs font-bold text-gray-500 uppercase tracking-wider px-1">Confirm
                                        New Password <span class="text-red-500">*</span></label>
                                    <div class="relative flex items-center">
                                        <input [type]="confirmPasswordVisible ? 'text' : 'password'"
                                            [(ngModel)]="passwordFormObj.confirm_new_password"
                                            placeholder="Re-enter new password"
                                            class="w-full px-4 py-3 bg-white border rounded-xl text-sm transition-all focus:ring-4 focus:ring-brandAccent/10"
                                            [class.border-red-500]="passwordFormObj.confirm_new_password && passwordFormObj.new_password !== passwordFormObj.confirm_new_password"
                                            [class.border-green-500]="passwordFormObj.confirm_new_password && passwordFormObj.new_password === passwordFormObj.confirm_new_password && policyErrors.length === 0"
                                            [class.border-brandAccent/10]="!passwordFormObj.confirm_new_password">
                                        <button (click)="confirmPasswordVisible = !confirmPasswordVisible"
                                            class="absolute right-4 text-gray-400 hover:text-brandPurple transition-colors p-1 focus:outline-none">
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                *ngIf="!confirmPasswordVisible">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                *ngIf="confirmPasswordVisible">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 012.23-4.04m4.845-1.761A9.959 9.959 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21m-6.875-10.125A3.375 3.375 0 1110.5 13.5l3.375-3.375z" />
                                            </svg>
                                        </button>
                                    </div>

                                    <!-- Password Mismatch Error -->
                                    <div *ngIf="passwordFormObj.confirm_new_password && passwordFormObj.new_password !== passwordFormObj.confirm_new_password"
                                        class="text-xs text-red-500 font-medium px-1 mt-2">
                                        • Passwords do not match
                                    </div>
                                </div>
                            </div>

                            <div
                                class="mt-10 flex flex-col sm:flex-row gap-4 items-center justify-end border-t border-brandAccent/10 pt-8">
                                <button (click)="closeUpdatePassword()"
                                    class="w-full sm:w-auto px-8 py-3.5 text-gray-500 hover:text-gray-700 font-black uppercase text-xs tracking-widest hover:bg-gray-50 rounded-2xl transition-all">Cancel</button>
                                <button (click)="resetPassword()"
                                    [disabled]="isResettingPassword || policyErrors.length > 0 || !passwordFormObj.new_password || !passwordFormObj.confirm_new_password || passwordFormObj.new_password !== passwordFormObj.confirm_new_password"
                                    class="w-full sm:w-auto px-10 py-3.5 bg-brandAccent hover:bg-brandPurple text-white font-black uppercase text-xs tracking-widest rounded-2xl shadow-xl shadow-brandAccent/20 hover:shadow-brandAccent/40 transition-all hover:-translate-y-0.5 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0">
                                    {{ isResettingPassword ? 'Resetting... Password' : 'Reset Password' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Hide/Show columnVisibility -->
            <div *ngIf="isColumnSettingsVisible" class="fixed inset-0 z-[190] flex justify-end">
                <div class="absolute inset-0 bg-black/30 backdrop-blur-sm" (click)="isColumnSettingsVisible = false">
                </div>
                <div
                    class="relative w-80 bg-white h-full shadow-2xl flex flex-col overflow-y-auto animate-in slide-in-from-right duration-300">
                    <div class="px-6 py-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                        <div>
                            <h2 class="text-sm font-black text-gray-900 uppercase tracking-widest">Column Display</h2>
                            <p class="text-[10px] text-gray-400 mt-0.5 font-bold uppercase">Toggle visibility</p>
                        </div>
                        <button class="p-2 hover:bg-gray-100 rounded-xl transition-all"
                            (click)="isColumnSettingsVisible = false">
                            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="p-6 flex flex-col gap-5">
                        <label
                            *ngFor="let col of ['name', 'username', 'status', 'email', 'base_location', 'Is Service Account', 'action','view']"
                            class="flex items-center justify-between group cursor-pointer p-2 hover:bg-gray-50 rounded-xl transition-all">
                            <span
                                class="text-xs font-bold text-gray-600 uppercase tracking-tight group-hover:text-brandPurple">{{
                                col.replace('_', ' ') }}</span>
                            <input type="checkbox"
                                [(ngModel)]="columnVisibility[col === 'Is Service Account' ? 'is_service_accounts' : col]"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-all cursor-pointer">
                        </label>
                    </div>
                </div>
            </div>

        </div>
        <footer class="login-footer">
            <span *ngIf="copyrightDetails">
                &copy; {{ copyrightDetails.from_year }} - {{ copyrightDetails.to_year }},
                Retail Calculus or its affiliates. All rights reserved.
            </span>
            <span *ngIf="!copyrightDetails">
                &copy; 2016 - 2026, Retail Calculus or its affiliates. All rights reserved.
            </span>

            <div class="footer-links">
                <a href="javascript:void(0)">Privacy Policy</a>
                <a href="javascript:void(0)">Terms of Use</a>
                <span class="version" *ngIf="copyrightDetails?.app_version">
                    Version {{ copyrightDetails.app_version }}
                </span>
            </div>
        </footer>
    </div>
</div>